export const LINKS = {
  root: "/",
  capture: "/capture",
  upload: "/upload",
  adjust: "/adjust",
  desktopRoot: "/desktop",
  mobileRoot: "/mobile"
}